import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const blackKite = defineConnector({
  identifier: "blackKite",
  name: "Black Kite",
  tagLine: "Third-party cyber risk",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.blackkitetech\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a client credential",
      items: [
        {
          kind: "markdown",
          content:
            "Navigate to the [Black Kite API Integration Details](https://app.blackkitetech.com/Integration) page, click “New Client Credential”, fill in the form, select a role, and copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://app.blackkitetech.com/api/v2/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://app.blackkitetech.com/api/v2/companies",
  },
});
